import FilterMenu from "./FilterMenu";

const AndOrFilter = ({
  filterName,
  fieldName,
  options,
  appliedFilters,
  setAppliedFilters,
  setFilterLogic,
  ...props
}) => {
  return (
    <FilterMenu
      filterName={filterName}
      fieldName={fieldName}
      options={options}
      appliedFilters={appliedFilters}
      setAppliedFilters={setAppliedFilters}
      logicControl={true}
      setFilterLogic={setFilterLogic}
      {...props}
    />
  );
};

export default AndOrFilter;
